export default "__VITE_ASSET__CCwVK0y4__"